export default function ReportsRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('reports', {
      url: '/reports',
      template: require('./reports.html'),
      controller: 'ReportsController',
      redirectTo: 'reports.list',
      ncyBreadcrumb: {
        label: "{{'Analytics' | translate}}"
      },
      requiredFeatures: ['analytics']
    })
    .state('reports.dashboards', {
      url: '/dashboards',
      helpModuleId: 'analytics',
      helpState: 'report.dashboards',
      template: '<tableau-report class="tableau-container" />',
      ncyBreadcrumb: {
        label: "{{'Dashboards' | translate}}"
      },
      requiredFeatures: ['analytics', 'analytics.tableau']
    })
    .state('reports.list', {
      url: '',
      helpModuleId: 'analytics',
      helpState: 'report.base',
      template: '<reports-list></reports-list>',
      ncyBreadcrumb: {
        label: "{{'Business Insights' | translate}}"
      },
      requiredFeatures: ['analytics']
    })
    .state('reports.jobschedules', {
      template: require('./jobschedules/jobs.html'),
      controller: 'JobsController',
      url: '/jobschedules',
      helpModuleId: 'analytics',
      helpState: 'analyticsschedules',
      ncyBreadcrumb: {
        label: "{{'Scheduled Reports' | translate}}"
      },
      requiredFeatures: ['analytics.schedules']
    })
    .state('reports.jobschedulesjob', {
      template: require('./jobschedules/job/job.create.html'),
      controller: 'JobCreateController',
      url: '/jobschedules/job',
      helpModuleId: 'analytics',
      helpState: 'analyticsschedules',
      ncyBreadcrumb: {
        parent: 'report.jobschedules',
        label: "{{'Job' | translate}}"
      },
      requiredFeatures: ['analytics.schedules.manage']
    })
    .state('reports.jobscheduledetail', {
      url: '/jobschedules/job/{id}',
      template: require('./jobschedules/job/job.detail.html'),
      controller: 'JobDetailController',
      helpModuleId: 'analytics',
      helpState: 'analyticsschedules',
      ncyBreadcrumb: {
        label: '{{schedule.jobName}}',
        parent: 'reports.jobschedules'
      },
      requiredFeatures: ['analytics.schedules']
    })
    .state('reports.jobschedule-edit', {
      url: '/jobschedules/job/{id}/edit',
      template: require('./jobschedules/job/job.update.html'),
      controller: 'JobUpdateController',
      helpModuleId: 'analytics',
      ncyBreadcrumb: {
        label: "{{'Edit' | translate}}",
        parent: 'reports.jobscheduledetail'
      },
      requiredFeatures: ['analytics.schedules.manage']
    })
    .state('reports.detail', {
      url: '/detail/?reportId',
      helpModuleId: 'analytics',
      helpState: 'report.detail',
      template: require('./reportview/reports.detail.html'),
      controller: 'ReportsDetailController',
      ncyBreadcrumb: {
        parent: 'reports.list',
        label: '{{reportName | translate}}'
      },
      params: {
        reportName: ''
      }
    })
    .state('reports.interactive-report', {
      url: '/detail/interactive/:reportId',
      helpModuleId: 'analytics',
      helpState: 'report.detail',
      params: {
        reportName: ''
      },
      template: '<interactive-report></interactive-report>',
      ncyBreadcrumb: {
        parent: 'reports.list',
        label: '{{$ctrl.reportName | translate}}'
      }
    });
}
